import styled from 'styled-components';

interface IContainer {
  isShow: boolean;
}

export const Container = styled.div<IContainer>`
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  top: ${({ isShow }) => (isShow ? 0 : -100)}vh;
  opacity: ${({ isShow }) => (isShow ? 1 : 0)};
  transition: opacity ease-in-out 300ms;
  div.overlay {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(25, 25, 25, 0.5);
  }
  > span {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 2;
    transition: opacity ease-out 0.1s;
    &:hover {
      opacity: 0.7;
    }
  }
`;

interface IIFrame {
  hasError: boolean;
}

export const IFrame = styled.iframe<IIFrame>`
  width: 100%;
  height: 100%;
  display: ${({ hasError }) => (hasError ? 'none' : 'unset')};
`;

export const Content = styled.div`
  width: 100vw;
  background-color: #ffffff;
  max-width: 90vw;
  height: calc(100vh - 40px);
  margin-top: 0;
  top: 20px;
  z-index: 2;
`;
